module.exports = __webpack_public_path__ + "img/deliverable-ejaf-tech-canada.bafcce26.png";